import React from 'react';
import SingleValueIcon from '@splunk/dashboard-visualizations/SingleValueIcon';

export default () => (
    <SingleValueIcon
        options={{}}
        encoding={{
            trend: 'primary.bar',
        }}
        dataSources={{
            primary: {
                data: {
                    columns: [
                        ['1', '62', '103', '308', '587', '876', '930', '1320'],
                        ['1', '62', '103', '308', '587', '876', '1195', '1220'],
                    ],
                    fields: [
                        {
                            name: 'foo',
                        },
                        {
                            name: 'bar',
                        },
                    ],
                },
                meta: {},
            },
        }}
    />
);
